import { ACTION } from "./command/action";
import { ICOMMAND, IKeyMaybeValue, IRESPONSE, RESULT } from "./command/icommand";
import { baseParamsType } from "./command/baseparams";
import { JSONString } from "../@types";

/**
 use https://www.deepl.com/de/docs-api/translate-text/translate-text/
 for sourceLanguage & targetLanguage values
  */
export class CMDP_DEEPL implements ICOMMAND {
  public action: ACTION = ACTION.CMDP_DEEPL;
  public params: baseParamsType & {
    text: string;
    sourceLanguage?: string;
    targetLanguage: string;
    deeplId?: string;
  };
}

export class CMDP_DEEPL_RESPONSE extends CMDP_DEEPL implements IRESPONSE {
  public result: RESULT;

  public commands: ICOMMAND[];

  public values: IKeyMaybeValue & {
    text: string;
    detectedLanguage: string;
  };
}

export class CMDP_DEEPLGETLANGUAGES implements ICOMMAND {
  public action: ACTION = ACTION.CMDP_DEEPLGETLANGUAGES;
  public params: baseParamsType & {
    text: string;
    sourceLanguage?: string;
    targetLanguage: string;
    deeplId?: string;
  };
}

export type DeeplLanguage = {
  language: string;
  name: string;
};

export class CMDP_DEEPLGETLANGUAGES_RESPONSE extends CMDP_DEEPL implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: {
    sourceLanguages?: JSONString<DeeplLanguage[]>;
    targetLanguages?: JSONString<DeeplLanguage[]>;
  };
}
